interface SkeletonBlockProps {
  height?: string;
  className?: string;
}

export function SkeletonBlock({ height = 'h-32', className = '' }: SkeletonBlockProps) {
  return (
    <div
      className={`animate-pulse bg-zinc-100 rounded-xl ${height} ${className}`}
      aria-hidden="true"
    />
  );
}
